<script>

    import { toast } from 'bulma-toast'
    import { notificationsStore, modalStore } from '../stores'
    
    import NotificationsService from '../$services/notifications.service.js'
    import DateMethod from '../$methods/date.method.js'

    import Table from '../$components/table.svelte'
    import Button from '../$components/button.svelte'

    let loading = false

    getNotifications()

    async function getNotifications() {

        loading = true
        const resp = await NotificationsService.getNotifications()
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        notificationsStore.set(resp.data.global)
    }

</script>

<Table items={ $notificationsStore.length } { loading }>
    <thead>
        <tr>
            <th>#</th>
            <th>Tema</th>
            <th>Mensaje</th>
            <th>Fecha</th>
            <th class="has-text-right">Acciones</th>
        </tr>
    </thead>
    <tbody>
        {#each $notificationsStore as notification, index}
            <tr>
                <td>{ index + 1 }</td>
                <td>{ notification.subject }</td>
                <td>{ notification.message }</td>
                <td>{ DateMethod.dateTimeLarge(notification.created) }</td>
                <td class="has-text-right">
                    <Button on:click={() => modalStore.open('notification', 'modal', notification)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>